module.exports = __webpack_public_path__ + "static/media/pic_corporateplan.71e68437.jpg";